import React, { FC } from 'react';
import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { CollaborativeUser } from 'app/components/Song/Lyrics/TextEditor/types';
import {
  ListItemAvatar,
  ListItemText,
  TableList,
} from 'app/components/ChakraTableList';
import { getAvatarImage } from 'app/utils/utils';

interface LiveUsersDialogProps {
  open: boolean;
  users: Array<CollaborativeUser & { isSelf?: boolean }>;
  onClose: () => void;
}

export const LiveUsersDialog: FC<LiveUsersDialogProps> = ({
  open,
  onClose,
  users,
}) => (
  <Modal isOpen={open} onClose={onClose}>
    <ModalOverlay />
    <ModalContent>
      <ModalHeader data-testid="dialog-title" title="Live Editors">
        Live Editors
      </ModalHeader>
      <ModalBody data-testid="dialog-content">
        <TableList
          columns={[
            { key: 'avatar', name: '', accessory: true },
            { key: 'name', name: '' },
            { key: 'color', name: '', accessory: true },
          ]}
          rows={users.map((user) => ({
            avatar: (
              <ListItemAvatar
                initials={user.profile?.initials}
                src={getAvatarImage(user.profile?.profileImages)}
                colors={user.profile?.avatarColors}
              />
            ),
            name: (
              <ListItemText
                data-testid="username"
                primaryTextProps={{
                  display: 'flex',
                }}
                primary={
                  <>
                    <Text overflow="hidden" textOverflow="ellipsis">
                      {user.profile?.displayName || ''}
                    </Text>
                    <Text>{user.isSelf ? ' (You)' : ''}</Text>
                  </>
                }
              />
            ),
            color: !user.isSelf && (
              <Box
                width={2}
                height={2}
                borderRadius="100%"
                margin="auto"
                bg={user.profile?.avatarColors?.text}
              />
            ),
          }))}
        />
      </ModalBody>
      <ModalFooter data-testid="dialog-actions">
        <Button onClick={onClose}>Close</Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
